import React from 'react';
import styled from 'styled-components';
import { ImpContainer, ImpFlex, ImpHoverable, ImpImage, ImpShimmer, ImpSpacer, ImpText, elevation, zIndex, } from '../..';
import { fonts } from '../../DesignSystem/typography';
const CARD_HEIGHT = 162;
const CARD_WIDTH = 258;
export const CARD_BORDER_RADIUS = 12;
const cardShadow = (shadowOnHover) => {
    return shadowOnHover
        ? `
    transition: 0.3s;
    :hover {
      box-shadow: ${elevation.cardBackground};
    }`
        : `box-shadow: ${elevation.cardBackground};`;
};
const CardContainer = styled(ImpContainer) `
  height: fit-content;
  width: fit-content;
  z-index: ${zIndex.card};
`;
const CardWrapper = styled(ImpContainer) `
  user-select: none;
  border-radius: ${(props) => props.borderRadiusNum}px;

  * {
    border-radius: ${(props) => props.borderRadiusNum}px;
  }
  ${(props) => !props.hideShadow && cardShadow(props.shadowOnHover)}
  ::before {
    cursor: ${(props) => props.cursor};
    content: '';
    display: block;
    position: absolute;
    width: ${(props) => (props.width ? props.width : `${props.widthNum}px`)};
    height: ${(props) => (props.width ? 'auto' : `${props.heightNum}px`)};
    border-radius: ${(props) => props.borderRadiusNum}px;
    box-shadow: ${(props) => (props.hideShadow ? 'none' : elevation.cardInset)};
    z-index: ${zIndex.cardWrapper};
  }
`;
const NameContainer = styled(ImpContainer) `
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 50;
`;
const NameOnCard = styled.p `
  && {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.005em;
    font-family: ${fonts.medium};

    margin: 0;
    padding: 0;
    font-style: normal;
    font-feature-settings: 'ss02' on, 'ss09' on, 'zero' on;
    display: inline-block;
    background-color: black;
    color: transparent;
    text-shadow: 0 -0.4px 0.2px rgba(255, 255, 255);
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;

    border-radius: 0px;
  }
`;
export default function ImpCard({ src, subtitle, subtitleColor, handleClick, shimmer = false, hoverable = false, shadowOnHover = false, hideShadow = false, shimmerOnce = false, width, heightPx = CARD_HEIGHT, widthPx = CARD_WIDTH, borderRadiusPx = CARD_BORDER_RADIUS, dataTestId = 'card', nameOnCard, id, }) {
    const renderImage = () => (React.createElement(ImpImage, { src: src, height: width ? 'auto' : `${heightPx}px`, width: width ? width : `${widthPx}px`, alt: "card image" }));
    const wrapWithShimmer = (children) => shimmer ? (React.createElement(ImpShimmer, { shimmerOnce: shimmerOnce }, children)) : (children);
    const wrapWithHoverable = (children) => hoverable ? (React.createElement(ImpHoverable, { height: heightPx, width: widthPx, borderRadius: borderRadiusPx }, children)) : (children);
    return (React.createElement(CardContainer, { dataTestId: dataTestId, onClick: handleClick, cursor: handleClick ? 'pointer' : 'default', id: id },
        React.createElement(ImpFlex, { fluid: true, direction: "column", align: "center" },
            wrapWithHoverable(React.createElement(CardWrapper, { cursor: handleClick ? 'pointer' : 'default', shadowOnHover: shadowOnHover, width: width, heightNum: heightPx, widthNum: widthPx, borderRadiusNum: borderRadiusPx, hideShadow: hideShadow },
                nameOnCard && (React.createElement(NameContainer, null,
                    React.createElement(NameOnCard, { color: "transparent" }, nameOnCard))),
                wrapWithShimmer(renderImage()))),
            subtitle && (React.createElement(React.Fragment, null,
                React.createElement(ImpSpacer, { height: "s" }),
                React.createElement(ImpText, { typography: "body2", color: subtitleColor }, subtitle))))));
}
//# sourceMappingURL=ImpCard.js.map